import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PollImageLikiees from './PollImageLikiees';
import PollImageProjects from './PollImageProjects';
import ManageModal from 'shared/components/modals/ManageModal';
import PollImagePhotos from './PollImagePhotos';

const PollImageSelection = ({ onCancel, onChooseImages, existForm }) => {
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState();
  const [currentProject, setCurrentProject] = useState();
  const [currentProduct, setCurrentProduct] = useState();
  const [step, setStep] = useState('project');

  const onSelectProject = project => {
    setCurrentProject(project);
    setStep('likiee');
  };

  const onSelectProduct = product => {
    setCurrentProduct(product);
    setStep('photos');
  };

  const onCancelClick = () => {
    if (step === 'likiee') {
      setStep('project');
    } else if (step === 'photos') {
      setStep('likiee');
    } else {
      onCancel();
    }
  };

  const onImageSelect = () => {
    onChooseImages &&
      onChooseImages({
        likieeId: currentProduct?.id,
        image: activeImage,
      });
  };

  return (
    <ManageModal
      title={t('title_select_poll_image')}
      subTitle={currentProduct?.name || (currentProject && (currentProject?.name || t('text_all_likiess'))) || ''}
      sumbitButton={t('btn_choose')}
      onCloseModal={onCancelClick}
      onSubmit={step === 'photos' ? onImageSelect : ''}
      isButtonDisabled={step === 'photos' && !activeImage}
      classNameContent='mb-20'
      onBackClick={onCancelClick}
    >
      {step === 'project' && <PollImageProjects onSelectProject={onSelectProject} />}
      {step === 'likiee' && <PollImageLikiees project={currentProject} onSelectProduct={onSelectProduct} />}
      {step === 'photos' && (
        <PollImagePhotos activeImage={activeImage} setActiveImage={setActiveImage} product={currentProduct} />
      )}
    </ManageModal>
  );
};

export default PollImageSelection;
